import React from 'react';
import { CheckIcon, LockIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { PriceBlock } from './PriceBlock';
import { OFFER_INCLUDES } from './salesData';
export function OfferSection() {
  return <section id="comprar" className="bg-sand py-12 sm:py-16" data-id="element-260" data-mp="8mn50etwilza">
      <div className="mx-auto max-w-2xl px-5" data-id="element-261" data-mp="ddvh5imm8lg5">
        <div className="rounded-3xl border border-stone bg-ivory p-5 text-center shadow-[0_30px_70px_-50px_rgba(10,26,51,0.6)] sm:p-9" data-id="element-262" data-mp="dfq04rebu3hl">
          <h2 className="font-display text-[1.2rem] font-bold uppercase leading-tight text-charcoal sm:text-[1.7rem]" data-id="element-263" data-mp="metj7vdhuiw3">
            Todo lo que te llevás hoy
          </h2>

          <div className="mt-4 rounded-2xl bg-charcoal px-5 py-4 text-ivory" data-id="element-264" data-mp="repsoa4yn2j1">
            <p className="font-display text-lg font-bold uppercase leading-tight" data-id="element-265" data-mp="wbof06idu56o">
              Método Consultorio Rentable
            </p>
            <p className="mt-1 font-sans text-[0.78rem] font-semibold uppercase tracking-[0.14em] text-gold-soft" data-id="element-266" data-mp="2y4couypj7qvf">
              Sistema de implementación en 5 tomos
            </p>
            <p className="mt-1.5 font-sans text-[0.78rem] font-semibold uppercase tracking-[0.14em] text-ivory/70" data-id="element-267" data-mp="12plamqezx788">
              + 5 recursos extra de regalo
            </p>
          </div>

          <ul className="mx-auto mt-5 grid max-w-md gap-1.5 text-left sm:grid-cols-2" data-id="element-268" data-mp="sxyqu5oldztv">
            {OFFER_INCLUDES.map(item => <li key={item} className="flex items-start gap-2" data-id="element-269" data-mp="1lm4dixz7hywc">
                <CheckIcon className="mt-[3px] h-3.5 w-3.5 shrink-0 text-gold" aria-hidden data-id="element-270" data-mp="1lll4y7vg4muz" />
                <span className="font-sans text-[0.82rem] leading-snug text-charcoal/80" data-id="element-271" data-mp="1go2uue5p01le">
                  {item}
                </span>
              </li>)}
          </ul>

          <PriceBlock className="mt-6" size="lg" data-id="element-272" data-mp="17ltlvsq2oga4" />

          <div className="mt-5 flex justify-center" data-id="element-273" data-mp="169gkupgqi14">
            <CTAButton label="QUIERO HACER MÁS RENTABLE MI CONSULTORIO" className="w-full max-w-[26rem] px-4" data-id="element-274" data-mp="184147wto84o" />
          </div>

          <p className="mt-2.5 font-sans text-[0.75rem] text-charcoal/65" data-id="element-275" data-mp="3ttq2imgws9j1">
            Acceso inmediato después de tu compra.
          </p>
          <p className="mt-1 font-sans text-[0.72rem] text-charcoal/55" data-id="element-276" data-mp="2mx05fadq4cx">
            Pago seguro · Garantía 7 días
          </p>

          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 border-t border-stone pt-4 font-sans text-[0.7rem] text-charcoal/60" data-id="element-277" data-mp="3ouwl4iyi3ydl">
            <span className="inline-flex items-center gap-1.5" data-id="element-278" data-mp="3b1x4gdmzfy4g">
              <LockIcon className="h-3.5 w-3.5 text-gold" aria-hidden data-id="element-279" data-mp="3fuhx3bu5k56e" /> Pago seguro
            </span>
            <span aria-hidden className="text-charcoal/25" data-id="element-280" data-mp="3163o0j657khe">
              ·
            </span>
            <span data-id="element-281" data-mp="363ncsd0gvfnl">Mercado Pago</span>
            <span aria-hidden className="text-charcoal/25" data-id="element-282" data-mp="364onuhhhg25b">
              ·
            </span>
            <span data-id="element-283" data-mp="2s55rsn1y4h9d">Tarjetas de crédito</span>
          </div>
        </div>
      </div>
    </section>;
}